import { render, staticRenderFns } from "./ErrorSnackbar.vue?vue&type=template&id=f6ecd7c6&scoped=true&lang=html&"
import script from "./ErrorSnackbar.vue?vue&type=script&lang=js&"
export * from "./ErrorSnackbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6ecd7c6",
  null
  
)

export default component.exports